import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert, Spinner } from '@easydent/shared-ui';
import { demoLogin } from '@/lib/api';
import { useAuthStore } from '@/stores/authStore';

/**
 * One-click entry to the demo sandbox, the same courtesy the clinic app gives doctors. Without it
 * an imaging centre evaluating easyDent has to be handed credentials by a human — which is exactly
 * why nobody ever tried the supplier portal.
 */
const DemoPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const setSession = useAuthStore((s) => s.setSession);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    demoLogin()
      .then((s) => { setSession(s.accessToken, s.name); navigate('/', { replace: true }); })
      .catch(() => setError(t('demo.unavailable', 'The demo is not available right now.')));
  }, [navigate, setSession, t]);

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      {error
        ? <Alert variant="error">{error}</Alert>
        : <div className="flex flex-col items-center gap-3 text-sm text-muted">
            <Spinner size="lg" />
            {t('demo.signingIn', 'Opening the demo…')}
          </div>}
    </div>
  );
};

export default DemoPage;
